import Proxy from '../proxies/Proxy';

class FaqsProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param  {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('faqs', parameters);
  }

  bulkDestroy(ids) {
    return this.submit('post', `/${this.endpoint}/bulk-destroy`, { ids });
  }
}

export default FaqsProxy;
